import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageButtons, MessageType } from '../../../shared/models/messages.model';
import { MessagesStoreService } from '../../../shared/services/messages-store.service';

@Component({
standalone: false,
  selector: 'app-other-payment-info-dialog-entry',
  template: '',
})
export class OtherPaymentInfoDialogEntryComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router,
              private messagesStoreService: MessagesStoreService) {
  }

  public ngOnInit(): void {
    this.otherPaymentInfoShow();
  }


  private otherPaymentInfoShow() {
    this.messagesStoreService.setState({
      type: MessageType.WARNING,
      buttons: MessageButtons.CUSTOM,
      title: 'Masz już rozpoczętą płatność za inne opłaty',
      msg: 'Aby móc dodać opłatę do koszyka, najpierw dokończ poprzednio rozpoczętą płatność.',
      customButtons: [
        {
          label: 'Dokończ płatność',
          isAccent: true,
          onClick: this.navigateToPayment.bind(this),
        },
        {
          label: 'Zamknij',
          isAccent: false,
          onClick: this.close.bind(this),
        },
      ],
    });
  }

  private navigateToPayment(): Promise<boolean> {
    const startedPaymentId = this.route.snapshot.queryParamMap.get('startedPaymentId');
    return this.router.navigate([`/liabilities/pay/${startedPaymentId}/defer`]);
  }

  private close(): Promise<boolean> {
    return this.router.navigate(['../'], { relativeTo: this.route });
  }



}
